import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';
import { ValidationService, ValidationType } from '../../services/validation.service';
@Component({
  selector: 'app-signature',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility">
  <div class="hazard-description dynamic-paragraph">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <div class="singnature-field" [ngClass]="{'pointer-events' : !field.style.editability}">
      <div class="signature-pad">
        <app-signature-canvas [fieldId]="field.id" [fieldvalue]="field.value" [sectionDynamic]="field.section.dynamic" [signaturePreview]="field.value" [basedOnEditability]="field.style.editability" (signatureImage)="saveImage($event)" (clearFieldValue)="clear()"></app-signature-canvas>
      </div>
    </div>
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
</div>
`,
  styles: [`.display-none{display:none}`]
})
export class SignatureComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor(
    private _validationService: ValidationService
  ) {}
  clear() {
    this.field.value = undefined;
  }
  saveImage($event){
    this.field.value = { thumbnail: $event.thumbnail };
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  ngOnInit() {
  } 
}


// WEBPACK FOOTER //
// ./src/app/rFF/fields/signature/signature.component.ts